export default __webpack_public_path__ + "static/audi-iconfont-708e5e63d0e8e05f68470785a1b54713.woff2";